import api from './api';

/**
 * Project Service - Handles all project-related API calls
 */
class ProjectService {
  /**
   * Get project details by ID
   * @param {string} projectId - Project ID or slug
   * @returns {Promise<Object>} Project details and best submission
   */
  async getProject(projectId) {
    const response = await api.get(`/projects/${projectId}`);
    return response.data;
  }

  /**
   * Submit project solution
   * @param {string} projectId - Project ID
   * @param {string} code - User's solution code
   * @returns {Promise<Object>} Submission result with test results
   */
  async submitProject(projectId, code) {
    const response = await api.post(`/projects/${projectId}/submit`, { code });
    return response.data;
  }

  /**
   * Get user's submissions for a project
   * @param {string} projectId - Project ID
   * @returns {Promise<Array>} List of submissions
   */
  async getSubmissions(projectId) {
    const response = await api.get(`/projects/${projectId}/submissions`);
    return response.data.submissions;
  }

  /**
   * Get specific submission by ID
   * @param {string} projectId - Project ID
   * @param {number} submissionId - Submission ID
   * @returns {Promise<Object>} Submission details
   */
  async getSubmissionById(projectId, submissionId) {
    const response = await api.get(`/projects/${projectId}/submissions/${submissionId}`);
    return response.data.submission;
  }
}

export default new ProjectService();

